import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider as Rebass } from 'rebass';
import theme from './styles/rebass-theme';
import { Provider } from 'react-redux';
import configureStore from './core/store/configureStore'; 

import App from './containers/App';
import Limitations from './containers/Limitations';

import 'react-select/dist/react-select.css';
import '../node_modules/normalize.css/normalize.css';
import './styles/main.css'; 
import injectTapEventPlugin from "react-tap-event-plugin";
injectTapEventPlugin();


const store = configureStore();

const badBrowser = window.innerWidth <= 800 || window.navigator.userAgent.indexOf('MSIE ') !== -1;

ReactDOM.render(
  <Provider store={store}>
    <Rebass theme={theme}>
      {badBrowser
        ? <Limitations />
        : <Router>
            <App store={store}/>
          </Router>
      }
    </Rebass>
  </Provider>,
  document.getElementById('root')
);





// WEBPACK FOOTER //
// ./src/index.js